import {Component, OnDestroy, OnInit} from '@angular/core';
import {LocalStorageService} from '../share/localstorage.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import {StandortData} from './standort.model';
import {IDBPDatabase, openDB} from 'idb';
import {interval} from 'rxjs';
import {SyncService} from '../share/sync.service';
import {DataModel} from '../share/data.model';

@Component({
    selector: 'app-standort',
    templateUrl: './standort.component.html',
    styleUrls: ['./standort.component.css'],
    standalone: false
})
export class StandortComponent implements OnInit, OnDestroy {
    private db: IDBPDatabase;
    public fahrzeuge: StandortData[] = [];
    private alive = true;
    public selectedfzg = '0';
    private subscription: any;
    public center;
    public marker_fzg = {
        position: new google.maps.LatLng(0, 0), label: {
            color: 'red',
            text: 'Marker label 0',
        }, title: '', options: {}
    };


    public Ueberschrift: string = this.ls.get('APP_Ueberschrift');
    public aktualisierung = 'unbekannt';

    constructor(private ls: LocalStorageService, private SyncService: SyncService, private http: HttpClient) {
    }


    ngOnInit() {
        this.SyncService.sync('gps');


        this.subscription = this.SyncService.neueGPSDaten
            .subscribe(
                (Data: DataModel) => {
                    console.log('NEUE GPS DATA');
                    this.getFahrzeuge();
                }
            )

        //   this.marker_setzen(1,'test1', 'aktu',54.2,10.530009);
        // this.marker_setzen(2,'test2', 'aktu',54.3,10.530009);
    }















    async open_db() {       // Prüft ob die DB vorhanden ist, legt diese sonst an!
        this.db = await openDB('fapp-store', 1, {});
    }
    async getFahrzeuge() {
        await this.open_db()
            .then(() => {

                let data = this.db.getAll('gps');

                return data;
            }).then((data) => {
                this.fahrzeuge = data;
                if (this.selectedfzg == '0') {
                  this.selectedfzg = this.fahrzeuge[0].id.toString();
                  this.changefahrzeug();
                }
                if (this.alive) {
                    setTimeout(() => {
                        this.SyncService.sync('gps');
                    }, 5000);

                }
                console.log(this.fahrzeuge);

              //  this.marker_setzen(this.fahrzeuge[0].funkrufname, this.fahrzeuge[0].stand, parseFloat(this.fahrzeuge[0].lat), parseFloat(this.fahrzeuge[0].lng));

            });
    }






    changefahrzeug() {
       this.fahrzeuge.forEach((f)=> {
         if (f.id.toString() == this.selectedfzg) {
             this.marker_setzen(f.funkrufname, f.stand, parseFloat(f.lat), parseFloat(f.lng));
         }
       });

        //foreach ofthis.selectedfzg);
    }


    getData() {

        if (this.alive === true) {
            setTimeout(() => {
                //this.getData();
            }, 3000);

            const params = new HttpParams()

                .set('random', Math.random().toString());

            return this.http.get('https://apps.elw-trave-land.de/services/fahrzeug_position.php', {
                params: params,
                //headers: {ignoreLoadingBar: ''}

            })
                .subscribe(
                    (data: StandortData) => {
                        for (let i = 0; i < 3; i++) {


//                                this.lat = parseFloat(data[i].lat);
                            //   this.lng = parseFloat(data[i].lng);

                            //this.center = new google.maps.LatLng(this.lat, this.lng);
                            // this.marker_setzen(i, data[i].beschreibung, data[i].aktualisierung);


                        }

                    }
                );
        }
    }

    setcenter() {
    }

    marker_setzen(name, aktualisierung, lat, lng) {


             this.center = new google.maps.LatLng(lat, lng);
          this.aktualisierung = aktualisierung;


        this.marker_fzg = {
            position: new google.maps.LatLng(lat, lng)
            ,
            label: {
                color: 'red',
                text: name,
            },
            title: name,
            options: {animation: google.maps.Animation.BOUNCE},
        };


    }

    ngOnDestroy() {
        this.alive = false;

       console.log('############################dest');
       //alert('dest');
    }
}
